export default __webpack_public_path__ + "static/25-71f0ab6559eb585fc889cf4d369c473f.webp";